import React, { FunctionComponent } from 'react';
import { DataCategory, CompanyPerson, DataValueCompanyPagePeople } from '../../../types/companyDetail';

type Props = {
  companyPeople: CompanyPerson[];
  iconNoImg: string;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPagePeople;
};

export const Presentation: FunctionComponent<Props> = ({
  companyPeople,
  iconNoImg,
  dataCategory,
  dataValue,
}) => {
  if (!companyPeople || companyPeople.length === 0) return null;

  return (
    <section className="company__page__recruitments css-slider maskno" id="member">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">メンバー</h2>
      </div>
      <div className="company__page__member slides gtm-company_people-view-count" data-event-name='company_people on screen' data-category={dataCategory} data-value={dataValue}>
        {companyPeople.map((p) => {
          const imgSrc = p.image?.url ?? iconNoImg;
          return (
            <a
              key={p.id}
              href={`/company_people/${p.id}`}
              target="_blank"
              rel="noreferrer"
              className="company__page__recruitments__member"
              data-event="click"
              data-category={dataCategory}
              data-value={dataValue}
            >
              <img src={imgSrc} alt={`${p.id}の画像`} />
              <p>{p.name}</p>
              <p className="role">{p.position}</p>
            </a>
          );
        })}
      </div>
    </section>
  );
};
